import { View } from 'react-native';
import React, { Suspense, lazy, memo } from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import MenuIconCard from '@components/Global/MenuIconCard';
import { XStack } from 'tamagui';

const AnimatedLottieView = lazy(() => import('@utils/lottieAnimation'));

const LazyLottieView = (props) => (
  <Suspense fallback={<View />}>
    <AnimatedLottieView {...props} />
  </Suspense>
);

const UserMenu = ({ navigation }) => {
  return (
    <DefaultScreen style={{ backgroundColor: "transparent", left: 3 }}>
      <XStack gap={20} columnGap={20} rowGap={5} flexWrap="wrap" style={{ paddingBottom: 150, alignSelf: 'stretch', flexDirection: 'row', flexWrap: 'wrap' }}>
        <MenuIconCard 
          pressFunction={() => navigation.navigate('HRDashboard')} 
          subtitle="View HR statistics and overview" 
          cardTitle="HR Dashboard"
        >
          <LazyLottieView 
            source={require('@assets/animations/LordIcons/41-home-solid-edited.json')} 
            loop={true} 
            style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} 
            autoPlay 
          />
        </MenuIconCard>
        
        <MenuIconCard 
          pressFunction={() => navigation.navigate('EmployeeManagement')} 
          subtitle="Manage employee information and records" 
          cardTitle="Employee Management"
        >
          <LazyLottieView 
            source={require('@assets/animations/LordIcons/19-book-solid-edited (1).json')} 
            loop={true} 
            style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} 
            autoPlay 
          />
        </MenuIconCard>
        
        <MenuIconCard 
          pressFunction={() => navigation.navigate('LeaveManagement')} 
          subtitle="Handle leave requests and approvals" 
          cardTitle="Leave Management"
        >
          <LazyLottieView 
            source={require('@assets/animations/101700-calendar-animation.json')} 
            loop={true} 
            style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} 
            autoPlay 
          />
        </MenuIconCard>
        
        <MenuIconCard 
          pressFunction={() => navigation.navigate('AttendanceManagement')} 
          subtitle="Track employee attendance records" 
          cardTitle="Attendance Management"
        >
          <LazyLottieView 
            source={require('@assets/animations/LordIcons/178-work-solid-edited.json')} 
            loop={true} 
            style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} 
            autoPlay 
          />
        </MenuIconCard>
        
        <MenuIconCard 
          pressFunction={() => navigation.navigate('PayrollManagement')} 
          subtitle="Manage payroll and compensation" 
          cardTitle="Payroll Management"
        >
          <LazyLottieView 
            source={require('@assets/animations/52003-e-commerce-basket.json')} 
            loop={true} 
            style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} 
            autoPlay 
          />
        </MenuIconCard>
        
        <MenuIconCard 
          pressFunction={() => navigation.navigate('PerformanceReviews')} 
          subtitle="Review and track employee performance" 
          cardTitle="Performance Reviews"
        >
          <LazyLottieView 
            source={require('@assets/animations/star.json')} 
            loop={true} 
            style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} 
            autoPlay 
          />
        </MenuIconCard>
      </XStack>
    </DefaultScreen>
  )
}

export default memo(UserMenu);

